export const MESSAGE_ATTACHMENTS_BUCKET = 'message_attachments';

export const MESSAGES_POLL_INTERVAL_MS = 15_000;

export const FAQ_URL =
  'https://help-popularpays.lightricks.com/hc/en-us/categories/24969753771282-Creator-Experience';

// Mirrors the backend upload allowlist (ALLOWED_MIME_TYPES in
// app/controllers/api/v5/message_attachments_controller.rb) and Ember's ACCEPTED_MESSAGE_FILE_TYPES.
export const ACCEPTED_ATTACHMENT_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/tiff',
  'video/quicktime',
  'video/mp4',
  'video/x-m4v',
  'video/x-ms-wmv',
  'video/webm',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/mp4',
  'audio/x-m4a',
] as const;

export const ACCEPTED_ATTACHMENT_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'tiff',
  'tif',
  'mov',
  'mp4',
  'm4v',
  'wmv',
  'webm',
  'pdf',
  'docx',
  'xlsx',
  'pptx',
  'mp3',
  'wav',
  'm4a',
] as const;

export const MAX_ATTACHMENT_SIZE_BYTES = 100 * 1024 * 1024;

export const ATTACHMENT_ACCEPT_ATTR = ACCEPTED_ATTACHMENT_MIME_TYPES.join(',');
